var React = require('react');

function IconCheckboxRequiredInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Required"),React.createElement("g",{"id":"Page-1","key":1},React.createElement("g",{"id":"v02"},React.createElement("path",{"id":"Shape","d":"M23.5.19A23.39,23.39,0,0,0,0,23.43a23.5,23.5,0,0,0,47,0A23.39,23.39,0,0,0,23.5.19Zm0,3.1a20.14,20.14,0,1,1,0,40.28,20.14,20.14,0,1,1,0-40.28Zm11,10.83a1.57,1.57,0,0,0-1.08.48L20.37,27.92l-5.54-5.64a1.57,1.57,0,0,0-2.64.66,1.56,1.56,0,0,0,.39,1.51l6.66,6.77a1.56,1.56,0,0,0,1.13.48,1.54,1.54,0,0,0,1.12-.48L35.72,16.76a1.54,1.54,0,0,0-1.17-2.64Z","transform":"translate(0 -0.19)"})))]);
}

IconCheckboxRequiredInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 47 46.48"};

module.exports = IconCheckboxRequiredInline;

IconCheckboxRequiredInline.default = IconCheckboxRequiredInline;
